<template>
    <div class="filter-results" v-if="props.params.status !== '' || props.params.type !== 0 || props.params.flag !== 0 || props.params.brand !== 0">
        <div v-if="props.params.status !== 0" @click="clearFilter('status')" class="item">
            {{ typeText }} Status: {{ statusList[props.params.status].name }}<svg-icon name="close" />
        </div>

        <div v-if="props.params.type !== 0 && props.params.type !== ''" @click="clearFilter('type')" class="item">
            {{ typeText }} type: {{ typeList[props.params.type].name }}<svg-icon name="close" />
        </div>

        <div v-if="props.params.flag !== 0 && props.params.flag !== ''" @click="clearFilter('flag')" class="item">
            Flag: {{ flagList[props.params.flag].name }}<svg-icon name="close" />
        </div>

        <div v-if="props.params.anchor_status !== 0 && props.params.anchor_status !== ''" @click="clearFilter('anchor_status')" class="item">
            Profile Status: {{ creatorStausList[props.params.anchor_status].name }}<svg-icon name="close" />
        </div>

        <div v-if="props.params.brands.length > 0" class="flex">
            <div  v-for="(item, index) in props.params.brands" :key="index" @click="clearFilter('brand',item)" class="item" v-show="item.id !== 99999999">
                Brand: {{ item.text }}
                <svg-icon name="close" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useCollectionFilter } from '@/components/creator/collectionFilterFunction.js';

const props = defineProps({
    params: {
        type: [Object],
        default: () => { }
    },
    theType: {
        type: String,
        default: 'collection',//collection,post
    },
});

const emit = defineEmits(['update-filter']);
const { statusList, typeList, flagList, creatorStausList } = useCollectionFilter();

const typeText = computed(() => {
    if (props.theType === 'collection') {
        return 'Collection';
    } else if (props.theType === 'post') {
        return 'Post';
    }
    return '';
});

//+++++++++++++++++++++++++++++++++
const clearFilter = (type, row) => {
    if (type === 'status') {
        props.params.status = 0;
    }
    else if (type === 'anchor_status') {
        props.params.anchor_status = 0;
    }
    else if (type === 'type') {
        props.params.type = 0;
    }
    else if (type === 'flag') {
        props.params.flag = 0;
    }
    else if(type==='brand'){
        console.log('row.id',row)
        props.params.brands = props.params.brands.filter(item => item.id !== row.id);
    }
    emit('update-filter', props.params);
};
</script>

<style lang="scss">
.filter-results {
    margin-top: 16px;
    margin-bottom: 16px;
    display: flex;

    .flex{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap:8px;
    }

    .item {
        margin-right: 8px;
        padding: 6px 10px;
        display: flex;
        align-items: center;
        background: var(--bg-02);
        border: 1px solid var(--neutral);
        border-radius: 100px;
        color: var(--black-90);
        font: var(--font-med-12);
        cursor: pointer;
        transition: all 0.2s ease;

        svg {
            width: 8px;
            height: 8px;
            margin-left: 5px;
        }

        &:hover {
            background: var(--light-neutral);
        }
    }

    .tag-flex-box {
        display: flex;
        flex-wrap: wrap;
    }
}
</style>